// extracted by mini-css-extract-plugin
export default {"list":"AdminProductList_list__HZVo-","listContainer":"AdminProductList_listContainer__vgWrX"};